export const bankAccountStates = {
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
}
